// @ts-nocheck

export const localeCodes =  [
  "cs_CZ",
  "de_DE",
  "en_GB",
  "es_ES",
  "fr_BE",
  "fr_FR",
  "nl_BE",
  "nl_NL",
  "pl_PL",
  "sk_SK"
]
export const localeLoaders = {
  cs_CZ: [
    {
      key: "locale_cs_CZ_46json_20e36dd2",
      load: () => import("#nuxt-i18n/20e36dd2" /* webpackChunkName: "locale_cs_CZ_46json_20e36dd2" */),
      cache: true
    }
  ],
  de_DE: [
    {
      key: "locale_de_DE_46json_ac43b5d6",
      load: () => import("#nuxt-i18n/ac43b5d6" /* webpackChunkName: "locale_de_DE_46json_ac43b5d6" */),
      cache: true
    }
  ],
  en_GB: [
    {
      key: "locale_en_GB_46json_8c26e220",
      load: () => import("#nuxt-i18n/8c26e220" /* webpackChunkName: "locale_en_GB_46json_8c26e220" */),
      cache: true
    }
  ],
  es_ES: [
    {
      key: "locale_es_ES_46json_5e3a59b3",
      load: () => import("#nuxt-i18n/5e3a59b3" /* webpackChunkName: "locale_es_ES_46json_5e3a59b3" */),
      cache: true
    }
  ],
  fr_BE: [
    {
      key: "locale_fr_BE_46json_d361c0c6",
      load: () => import("#nuxt-i18n/d361c0c6" /* webpackChunkName: "locale_fr_BE_46json_d361c0c6" */),
      cache: true
    }
  ],
  fr_FR: [
    {
      key: "locale_fr_FR_46json_033e94e0",
      load: () => import("#nuxt-i18n/033e94e0" /* webpackChunkName: "locale_fr_FR_46json_033e94e0" */),
      cache: true
    }
  ],
  nl_BE: [
    {
      key: "locale_nl_BE_46json_4a970385",
      load: () => import("#nuxt-i18n/4a970385" /* webpackChunkName: "locale_nl_BE_46json_4a970385" */),
      cache: true
    }
  ],
  nl_NL: [
    {
      key: "locale_nl_NL_46json_83a6b7d4",
      load: () => import("#nuxt-i18n/83a6b7d4" /* webpackChunkName: "locale_nl_NL_46json_83a6b7d4" */),
      cache: true
    }
  ],
  pl_PL: [
    {
      key: "locale_pl_PL_46json_680a22cd",
      load: () => import("#nuxt-i18n/680a22cd" /* webpackChunkName: "locale_pl_PL_46json_680a22cd" */),
      cache: true
    }
  ],
  sk_SK: [
    {
      key: "locale_sk_SK_46json_aa9a31bf",
      load: () => import("#nuxt-i18n/aa9a31bf" /* webpackChunkName: "locale_sk_SK_46json_aa9a31bf" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "cs_CZ",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "de_DE",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "en_GB",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "es_ES",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "fr_BE",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "fr_FR",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "nl_BE",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "nl_NL",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "pl_PL",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "sk_SK",
    language: undefined,
    domains: [],
    defaultForDomains: []
  }
]

